import { createNotebook } from "@metablock/notebook";
import { useTheme } from "@mui/material/styles";

const useNotebook = () => {
  const theme = useTheme();
  return createNotebook(theme.palette.mode);
};

export default useNotebook;
